"use client";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CardContent, CardHeader } from "@/components/ui/card";
import LoginForm from "./login-form";
import MagicLinkForm from "./magic-link-form";
import OAuthButtons from "../oauth/oauth-buttons";

const LoginComponent = () => {
  return (
    <>
      <CardHeader className="pb-0 px-4 sm:px-6"></CardHeader>
      <CardContent className="px-4 sm:px-6">
        <Tabs defaultValue="email-password" className="w-full">
          <TabsList className="grid w-full grid-cols-2 h-10">
            <TabsTrigger value="email-password">メール/パスワード</TabsTrigger>
            <TabsTrigger value="magic-link">マジックリンク</TabsTrigger>
          </TabsList>

          <TabsContent value="email-password" className="mt-4 sm:mt-6">
            <LoginForm />
          </TabsContent>

          <TabsContent value="magic-link" className="mt-4 sm:mt-6">
            <MagicLinkForm />
          </TabsContent>
        </Tabs>

        <OAuthButtons className="mt-6" actionText="ログイン" />
      </CardContent>
    </>
  );
};

export default LoginComponent;

